import Modal from "react-modal";
import "../../components/modal/ModalCss.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faTimes } from "@fortawesome/free-solid-svg-icons";
import { sendPost, sendPut } from "api/restUtil";
import { useEffect, useState } from "react";
import { modConfirm } from "js/common";
import BasicButton from "components/button/BasicButton";

/* 사용자 선택 팝업창 */
export default function ChangePwModal(props) {
    const { width, height, isOpen, title, onClose} = props;

        //const [showChangePassword, setShowChangePassword] = useState(false);
        const [currentPassword, setCurrentPassword] = useState("");
        const [newPassword, setNewPassword] = useState("");
        const [confirmPassword, setConfirmPassword] = useState("");
        const [passwordsMatch, setPasswordsMatch] = useState(true);
        const [showPw, setShowPw] = useState(false);
        const [showPw2, setShowPw2] = useState(false);
        const [showPw3, setShowPw3] = useState(false);
    
        const styleEye = {
            position : "absolute",right : "10px" ,bottom : "7px"
        };

		useEffect(() => {
			setShowPw(false);	// 화면 표시 상태가 변경되면 비밀번호 숨김으로 변경.
			setShowPw2(false);	// 화면 표시 상태가 변경되면 비밀번호 숨김으로 변경.
			setShowPw3(false);	// 화면 표시 상태가 변경되면 비밀번호 숨김으로 변경.
			setCurrentPassword("");
			setNewPassword("");
			setConfirmPassword("");
			setPasswordsMatch(true);
		}, [isOpen])

        const handleChange = (e) => {
            let { name, value } = e.target;

			// 한글 입력 불가. (비밀번호 모드일때는 한글 입력이 안되지만, text모드일때는 한글 입력이 가능 - 강제로 입력 못하도록)
			value = value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ/가-힣]/g, "");
    
            if (name === "newPassword") {
                setNewPassword(value.replace(/[ \t\n\r]+/g, ''));
            } else if (name === "confirmPassword") {
                setConfirmPassword(value.replace(/[ \t\n\r]+/g, ''));
            } else if (name === "currentPassword") {
                setCurrentPassword(value);
            }
        };
        
        useEffect(()=> {
            const match = newPassword !== null && newPassword === confirmPassword;
            setPasswordsMatch(match);
        },[confirmPassword, newPassword]);

        const onClick = async ()=> {

			if(currentPassword === "") {
				alert("현재 비밀번호를 입력하세요.");
				document.querySelector("#changePwModal #currentPassword").focus();
				return;
			}
			if(newPassword === "") {
				alert("새 비밀번호를 입력하세요.");
				document.querySelector("#changePwModal #newPassword").focus();
				return;
			}

			// 새 비밀번호 정책 확인
			if(!checkPwPolicy(newPassword)) {
				alert("비밀번호 정책을 확인해 주세요.");
				document.querySelector("#changePwModal #newPassword").select();
				return;
			}

			if(!passwordsMatch) {
				alert("새 비밀번호와 비밀번호 확인이 일치하지 않습니다.");
				document.querySelector("#changePwModal #confirmPassword").select();
				return;
			}
            if(!modConfirm()) {
                return;
            }
            const url = "/api/user/change-pw";
            const request = {
                nowPw : currentPassword,
                newPw : newPassword
            };
            const resultData = await sendPut(url, request);
            if(resultData.respCode === "SUCCESS") {
                alert("비밀번호가 변경되었습니다.");
                onClose();
            }
        };

	const checkPwPolicy = (pw) => {
		// 6자 미만 실패
		if(pw.length < 6) return false;
		// 12자 초과 실패
		if(pw.length > 12) return false;

		// 2가지 이상 혼합
		let useCnt = 0;
		// 영소
		if(/[a-z]/.test(pw)) useCnt += 1;
		// 영대
		if(/[A-Z]/.test(pw)) useCnt += 1;
		// 숫자
		if(/[0-9]/.test(pw)) useCnt += 1;
		// 특수문자 (영문/숫자를 제거하고 남는 문자로 확인)
		if(pw.replace(/[a-z|A-Z|0-9]/g, "") !== "") useCnt += 1;

		// 2가지 미만이면 실패
		if(useCnt < 2) return false;

		return true;
	}
    return (
        <Modal
            appElement={document.getElementById("root")}
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={title}
			id="changePwModal"
        >
            <div className="me-modal">
                <div className="me-modal-container" style={{width, height}}>
                    <div className="me-modal-inner">
                        <div className="me-modal-header handle-area">
                            <h4 className="header-title">{title}</h4>
                            <div className="header-close" onClick={onClose}>
                                <FontAwesomeIcon icon={faTimes} className="button" size="lg"/>
                            </div>
                        </div>

                        <div className="me-modal-body" >
                            <div className="content modal-form">
								<table className="data-table">
									<colgroup>
										<col width="30%" />
										<col width="*" />
									</colgroup>
									<tbody>
										<tr>
											<th>
												<label htmlFor="currentPassword">
													현재 비밀번호 : 
												</label>
											</th>
											<td>
												<input
													type={showPw ? "text" : "password"}
													className="basic-input"
													id="currentPassword"
													name="currentPassword"
													onChange={handleChange}
												/>
												<div style={{position : "relative"}}>
												{showPw ? (
													<FontAwesomeIcon icon={faEyeSlash} onClick ={()=>setShowPw(false)} className="button" style={styleEye}/>
												) : (
													<FontAwesomeIcon icon={faEye} onClick ={()=>setShowPw(true)} className="button" style={styleEye}/>
												)}
												</div>
											</td>
										</tr>
										<tr>
											<th>
												<label htmlFor="newPassword">
													새 비밀번호 : 
												</label>
											</th>
											<td>
												<input
													type={showPw2 ? "text" : "password"}
													className="basic-input"
													id="newPassword"
													name="newPassword"
													value={newPassword}
													onChange={handleChange}
													placeholder="띄어쓰기는 입력되지 않습니다."
												/>
												<div style={{position : "relative"}}>
												{showPw2 ? (
													<FontAwesomeIcon icon={faEyeSlash} onClick ={()=>setShowPw2(false)} className="button" style={styleEye}/>
												) : (
													<FontAwesomeIcon icon={faEye} onClick ={()=>setShowPw2(true)} className="button" style={styleEye}/>
												)}
												</div>
											</td>
										</tr>
										<tr>
											<th></th>
											<td style={{paddingTop: "0"}}>
												<span style={{fontSize: "12px"}}>※ 6~12자 영문 대/소문자, 숫자, 특수문자. 2가지 이상 혼합.</span>
											</td>
										</tr>
										<tr>
											<th>
												<label htmlFor="confirmPassword">
													새 비밀번호 확인: 
												</label>
											</th>
											<td>
												<input
													type={showPw3 ? "text" : "password"}
													className="basic-input"
													id="confirmPassword"
													name="confirmPassword"
													value={confirmPassword}
													onChange={handleChange}
													placeholder="띄어쓰기는 입력되지 않습니다."
												/>
												<div style={{position : "relative"}}>
												{showPw3 ? (
													<FontAwesomeIcon icon={faEyeSlash} onClick ={()=>setShowPw3(false)} className="button" style={styleEye}/>
												) : (
													<FontAwesomeIcon icon={faEye} onClick ={()=>setShowPw3(true)} className="button" style={styleEye}/>
												)}
												</div>
												
											</td>
										</tr>
										<tr>
											<th></th>
											<td style={{paddingTop: "0"}}>
												{!passwordsMatch && (
													<span className="cherry" style={{fontSize: "12px"}}>새 비밀번호와 비밀번호 확인이 일치하지 않습니다.</span>
												)} 
												&nbsp;
											</td>
										</tr>

									</tbody>
								</table>
    
                            </div>
                        </div>
                        <div className="me-modal-footer mg-t-10 mg-b-20">
                            <div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel btn-full" onClick={onClose} />
								<BasicButton label="저장" className="btn-save btn-full" onClick={onClick} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};